import { useEffect, useMemo, useState } from "react";
import { ScreenSizeCategoryEnum } from "../../_common/enum/screenSizeCategory.enum";
import { getWindowSizeCategory, useScreenSize } from "../../_helpers/screenSize.helper";

export function useScreenCategory() {
    const screenSize = useScreenSize();
    const [category, setCategory] = useState<ScreenSizeCategoryEnum | null>(null);

    useEffect(() => {
        setCategory(getWindowSizeCategory(screenSize.width));
    }, [screenSize.width]);

    const isXS = category === ScreenSizeCategoryEnum.XS;
    const isSM = category === ScreenSizeCategoryEnum.SM;
    const isMobile = isXS || isSM;

    return useMemo(() => ({ category, isXS, isSM, isMobile }), [category, isXS, isSM, isMobile]);
}
